import { useRef } from "react";
import styled from "styled-components";

import Btn from "components/atoms/buttons";
import COLORS from "components/atoms/colors";

import useUpload from "apis/mutations/useUpload";
import { InputChange } from "types/Form";

interface Props {
  file?: string;
  name: string;
  onDispatch: (value: string) => void;
}

// 사업자등록증 or 명함 폼
const LicenseFile = ({ file, name, onDispatch }: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  // 이미지 업로드 api
  const upload = useUpload({
    onSuccess: (image) => onDispatch(image),
  });

  // 업로드한 이미지 상태 업데이트 이벤트
  const handleChange = (event: InputChange) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;
    upload(selectedFiles[0]);
  };

  const fileNames = file?.split(/[/.]/);
  const fileName = fileNames?.at(-2);
  const fileExtension = fileNames?.at(-1);

  return (
    <Container>
      <input
        ref={ref}
        name={name}
        type="file"
        className="hidden"
        onChange={handleChange}
        accept="image/*"
      />

      {file ? (
        <>
          <NameWrap>
            <Name>{fileName}</Name>
            <span className="flex-none">.{fileExtension}</span>
          </NameWrap>
          <Btn.Line
            onClick={() => ref?.current?.click()}
            type="button"
            size="xsSmall"
            width="45px"
          >
            수정
          </Btn.Line>
        </>
      ) : (
        <Btn.Line
          onClick={() => ref?.current?.click()}
          type="button"
          size="xsSmall"
          width="45px"
        >
          첨부
        </Btn.Line>
      )}
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 44px;
  padding: 12px;
  border: 1px solid ${COLORS.black["40%"]};
  border-radius: 4px;
`;

const NameWrap = styled.p`
  display: flex;

  span {
    font-size: 14px;
    word-break: break-all;
  }
`;

const Name = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default LicenseFile;
